import type { OrganizationTier } from '../types';

export interface PublicFormTierFeatures {
  packageSelection: boolean;
  mapBasedLocation: boolean;
  diagnosticChat: boolean;
  aiAgent: boolean;
  optionalRepairPackage: boolean;
}

const TIER_PERMISSIONS: Record<OrganizationTier, PublicFormTierFeatures> = {
  free: {
    packageSelection: false,
    mapBasedLocation: false,
    diagnosticChat: false,
    aiAgent: false,
    optionalRepairPackage: false,
  },
  basic: {
    packageSelection: true,
    mapBasedLocation: true,
    diagnosticChat: false,
    aiAgent: false,
    optionalRepairPackage: false,
  },
  professional: {
    packageSelection: true,
    mapBasedLocation: true,
    diagnosticChat: true,
    aiAgent: true,
    optionalRepairPackage: true,
  },
  advanced: {
    packageSelection: true,
    mapBasedLocation: true,
    diagnosticChat: true,
    aiAgent: true,
    optionalRepairPackage: true,
  },
};

export function canAccessFeature(
  tier: OrganizationTier | undefined,
  feature: keyof PublicFormTierFeatures
): boolean {
  if (!tier) return false;
  return TIER_PERMISSIONS[tier][feature];
}

export function isTierAtLeast(tier1: OrganizationTier, tier2: OrganizationTier): boolean {
  const tierOrder: Record<OrganizationTier, number> = {
    free: 0,
    basic: 1,
    professional: 2,
    advanced: 3,
  };
  return tierOrder[tier1] >= tierOrder[tier2];
}

export function getTierLabel(tier: OrganizationTier): string {
  const labels: Record<OrganizationTier, string> = {
    free: 'Free',
    basic: 'Basic',
    professional: 'Professional',
    advanced: 'Advanced',
  };
  return labels[tier];
}
